import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeStyle as _normalizeStyle, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-2ac4db2d"), n = n(), _popScopeId(), n);
const _hoisted_1 = ["src"];
const _hoisted_2 = {
  class: "avatar-upload-preview"
};
const _hoisted_3 = ["src"];
const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1));
import 'vue-cropper/dist/index.css';
import { VueCropper } from 'vue-cropper';
import { ref, reactive, onMounted, onBeforeUnmount } from 'vue';
import { debounce } from '@/plugins';
import { Plus, Minus, RefreshLeft, RefreshRight, Folder } from '@element-plus/icons-vue';
import { ElMessage } from "element-plus";
import { XiaoniuFrontedControllerService } from "../../../generated/services/XiaoniuFrontedControllerService";
import { useLoginUserStore } from "@/store/loginUser";
export default /*#__PURE__*/_defineComponent({
  __name: 'UserAvator',
  setup(__props) {
    const open = ref(false);
    const visible = ref(false);
    const title = ref('修改头像');
    const loading = ref(false);
    const computedGutter = ref(50);
    const loginUserStore = useLoginUserStore();
    const options = ref({
      img: loginUserStore.loginUser?.avatar === "" ? require("@/assets/xiaoniu-logo.png") : loginUserStore.loginUser.avatar,
      autoCrop: true,
      autoCropWidth: 200,
      autoCropHeight: 200,
      fixedBox: true,
      outputType: 'png',
      filename: 'avatar'
    });
    const cropper = ref();
    onMounted(() => {
      updateGutter();
      updateDialogWidth();
      window.addEventListener('resize', updateGutter);
      window.addEventListener('resize', updateDialogWidth);
    });
    const uploadImg = () => {
      loading.value = true;
      cropper.value.getCropBlob(async data => {
        let formData = new FormData();
        formData.append('avatarfile', data, options.value.filename);
        const res = await XiaoniuFrontedControllerService.avatarUsingPost1(formData);
        if (res.data.code === 200) {
          open.value = false;
          options.value.img = res.data.imgUrl;
          //更新登录用户的头像
          loginUserStore.updateUser({
            ...loginUserStore.loginUser,
            avatar: options.value.img
          });
          ElMessage.success("修改成功");
          visible.value = false;
        }
        loading.value = false;
      });
    };
    const previews = reactive({});
    const isMobile = () => {
      return window.innerWidth <= 768;
    };
    const dialogWidth = ref('80%');
    const updateDialogWidth = () => {
      dialogWidth.value = isMobile() ? '80%' : '50%';
    };
    const updateGutter = () => {
      computedGutter.value = window.innerWidth < 768 ? 20 : 50;
    };
    const editCropper = () => {
      open.value = true;
    };
    let resizeHandler = null;
    const modalOpened = () => {
      visible.value = true;
      if (!resizeHandler) {
        resizeHandler = debounce(() => {
          refresh();
        }, 100);
      }
      window.addEventListener('resize', resizeHandler);
    };
    const refresh = () => {
      cropper.value.refresh();
    };
    const requestUpload = () => {
      // console.log(123)
    };
    //图片缩放
    const changeScale = num => {
      num = num || 1;
      cropper.value.changeScale(num);
    };
    // 向左旋转
    const rotateLeft = () => {
      cropper.value.rotateLeft();
    };
    //向右旋转
    const rotateRight = () => {
      cropper.value.rotateRight();
    };
    const beforeUpload = file => {
      if (file.type.indexOf('image/') === -1) {
        ElMessage.error("文件格式错误，请上传图片类型,如：JPG，PNG后缀的文件。");
      } else {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => {
          options.value.img = reader.result;
          options.value.filename = file.name;
        };
      }
    };
    const realTime = data => {
      Object.assign(previews, data);
    };
    const closeDialog = () => {
      options.value.img = loginUserStore.loginUser?.avatar === "" ? require("@/assets/xiaoniu-logo.png") : loginUserStore.loginUser.avatar;
      visible.value = false;
      window.removeEventListener('resize', resizeHandler);
    };
    onBeforeUnmount(() => {
      window.removeEventListener('resize', resizeHandler);
      window.removeEventListener('resize', updateDialogWidth);
      window.removeEventListener('resize', updateGutter);
    });
    return (_ctx, _cache) => {
      const _component_el_col = _resolveComponent("el-col");
      const _component_el_row = _resolveComponent("el-row");
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_upload = _resolveComponent("el-upload");
      const _component_el_dialog = _resolveComponent("el-dialog");
      return _openBlock(), _createElementBlock("div", null, [_createElementVNode("div", {
        class: "user-info-head",
        onClick: editCropper
      }, [_createElementVNode("img", {
        src: options.value.img,
        title: "点击上传头像",
        class: "img-circle img-lg"
      }, null, 8, _hoisted_1)]), _createVNode(_component_el_dialog, {
        title: title.value,
        modelValue: open.value,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => open.value = $event),
        width: dialogWidth.value,
        "lock-scroll": false,
        "append-to-body": true,
        onOpened: modalOpened,
        onClose: closeDialog
      }, {
        default: _withCtx(() => [_createVNode(_component_el_row, null, {
          default: _withCtx(() => [_createVNode(_component_el_col, {
            xs: 24,
            md: 12,
            style: {
              height: '350px'
            }
          }, {
            default: _withCtx(() => [visible.value ? (_openBlock(), _createBlock(_unref(VueCropper), {
              key: 0,
              ref_key: "cropper",
              ref: cropper,
              img: options.value.img,
              info: true,
              autoCrop: options.value.autoCrop,
              autoCropWidth: options.value.autoCropWidth,
              autoCropHeight: options.value.autoCropHeight,
              fixedBox: options.value.fixedBox,
              outputType: options.value.outputType,
              onRealTime: realTime
            }, null, 8, ["img", "autoCrop", "autoCropWidth", "autoCropHeight", "fixedBox", "outputType"])) : _createCommentVNode("", true)]),
            _: 1
          }), _createVNode(_component_el_col, {
            xs: 24,
            md: 12,
            style: {
              height: '350px'
            }
          }, {
            default: _withCtx(() => [_createElementVNode("div", _hoisted_2, [_createElementVNode("img", {
              src: previews.url,
              style: _normalizeStyle(previews.img)
            }, null, 12, _hoisted_3)])]),
            _: 1
          })]),
          _: 1
        }), _hoisted_4, _createVNode(_component_el_row, {
          class: "button-row"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_col, {
            md: 12,
            xs: 24
          }, {
            default: _withCtx(() => [_createVNode(_component_el_row, null, {
              default: _withCtx(() => [_createVNode(_component_el_col, {
                xs: 24,
                sm: 8,
                class: "elColClass"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_upload, {
                  action: "#",
                  "http-request": requestUpload,
                  "show-file-list": false,
                  "before-upload": beforeUpload
                }, {
                  default: _withCtx(() => [_createVNode(_component_el_button, {
                    icon: _unref(Folder)
                  }, {
                    default: _withCtx(() => [_createTextVNode("选择")]),
                    _: 1
                  }, 8, ["icon"])]),
                  _: 1
                })]),
                _: 1
              }), _createVNode(_component_el_col, {
                xs: 24,
                sm: 16,
                class: "elColClass"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_row, {
                  gutter: computedGutter.value
                }, {
                  default: _withCtx(() => [_createVNode(_component_el_col, {
                    xs: 6,
                    sm: 4
                  }, {
                    default: _withCtx(() => [_createVNode(_component_el_button, {
                      icon: _unref(Plus),
                      onClick: _cache[0] || (_cache[0] = $event => changeScale(1))
                    }, null, 8, ["icon"])]),
                    _: 1
                  }), _createVNode(_component_el_col, {
                    xs: 6,
                    sm: 4
                  }, {
                    default: _withCtx(() => [_createVNode(_component_el_button, {
                      icon: _unref(Minus),
                      onClick: _cache[1] || (_cache[1] = $event => changeScale(-1))
                    }, null, 8, ["icon"])]),
                    _: 1
                  }), _createVNode(_component_el_col, {
                    xs: 6,
                    sm: 4
                  }, {
                    default: _withCtx(() => [_createVNode(_component_el_button, {
                      icon: _unref(RefreshLeft),
                      onClick: rotateLeft
                    }, null, 8, ["icon"])]),
                    _: 1
                  }), _createVNode(_component_el_col, {
                    xs: 6,
                    sm: 4
                  }, {
                    default: _withCtx(() => [_createVNode(_component_el_button, {
                      icon: _unref(RefreshRight),
                      onClick: rotateRight
                    }, null, 8, ["icon"])]),
                    _: 1
                  })]),
                  _: 1
                }, 8, ["gutter"])]),
                _: 1
              })]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_component_el_col, {
            md: 12,
            xs: 24,
            style: {
              "display": "flex",
              "justify-content": "center",
              "align-items": "center"
            }
          }, {
            default: _withCtx(() => [_createVNode(_component_el_button, {
              type: "primary",
              onClick: uploadImg,
              loading: loading.value
            }, {
              default: _withCtx(() => [_createTextVNode("提交")]),
              _: 1
            }, 8, ["loading"])]),
            _: 1
          })]),
          _: 1
        })]),
        _: 1
      }, 8, ["title", "modelValue", "width"])]);
    };
  }
});